import axiosClient from "./axiosClient";

// const serviceUrl = "http://42.96.44.215:10002";
// http://42.96.44.215:10002/qlkhambenh/refraction/list-refraction?page=1&size=10
const glassStoreService = {
  getListReceipt: async params => {
    const url = "/store/receipt/search-key/groups-kinh";
    const response = await axiosClient.get(url, {params: params});
    return response.data;
  },
  getDetailReceipt: async id => {
    const url = `/store/receipt/groups-kinh/by-id?id=${id}`;
    const response = await axiosClient.get(url);
    return response.data;
  },
  updateImportForm: async data => {
    const url = "/store/receipt/groups-kinh";
    const response = await axiosClient.put(url, data);
    return response.data;
  },
  deleteAGlasses: async id => {
    const url = "/qlkhambenh/refraction";
    const response = await axiosClient.delete(url, {params: {id}});
    return response.data;
  },
  postImportForm: async data => {
    const url = "/store/receipt/groups-kinh";
    const res = await axiosClient.post(url, data);
    return res.data;
  },
  getGlassesStore: async params => {
    // const params = { page: page, size: size };
    const url = "/store/glasses-store/list-glasses-store";
    const res = await axiosClient.get(url, {params: params});
    return res.data;
  },

  getListGlassInStore: async param => {
    const url = "/store/glasses-store/searchKey";
    const res = await axiosClient.get(url, {params: param});
    return res.data;
  },

  getListSuppliesType: async () => {
    const url = "/store/kinh-loai-vt/list-kinh-loai-vt-no-page";
    const res = await axiosClient.get(url);
    return res.data;
  },
  getListSuppliesPagination: async param => {
    const url = "/store/kinh-loai-vt/list-kinh-loai-vt";
    // const param = {page: page, limit: limit}
    const res = await axiosClient.get(url, {params: param});
    return res.data;
  },

  createSuppliesTypePage: async body => {
    const url = "/store/kinh-loai-vt/create";
    // const param = {page: page, limit: limit}
    const res = await axiosClient.post(url, body);
    return res.data;
  },

  editSuppliesTypePage: async body => {
    const url = "/store/kinh-loai-vt/update";
    // const param = {page: page, limit: limit}
    const res = await axiosClient.put(url, body);
    return res.data;
  },

  deleteSuppliesType: async id => {
    const url = "/store/kinh-loai-vt/delete";
    const param = {id: id};
    const res = await axiosClient.delete(url, {params: param});
    return res;
  },

  getListNhaKinh: async () => {
    const url = "/store/store/list-nha-kinh";
    const res = await axiosClient.get(url);
    return res.data;
  },
  getListSupplier: async (page, limit) => {
    const url = "/store/supplier/groups-kinh";
    const params = {page: page, limit: limit};
    const res = await axiosClient.get(url, {params});
    return res.data;
  },
  getListXuatXu: async (page, limit) => {
    const url = "/store/manufactured-country/list-manufactured-country";
    const params = {page: page, limit: limit};
    const res = await axiosClient.get(url, {params});
    return res.data;
  },

  createSupplierCatalog: async body => {
    const url = "/store/supplier/groups-kinh";
    const res = await axiosClient.post(url, body);
    return res.data;
  },

  editSupplierCatalog: async body => {
    const url = "/store/supplier/groups-kinh";
    const res = await axiosClient.put(url, body);
    return res.data;
  },

  deleteSupplierCatalog: async id => {
    const url = "/store/supplier/delete";
    const param = {id: id};
    const res = await axiosClient.delete(url, {params: param});
    return res;
  },
  getListStore: async (page, limit, isKhoAo = "true") => {
    const params = {page: page, limit: limit, isKhoAo: isKhoAo};
    const url = "/store/store/groups-kinh";
    const res = await axiosClient.get(url, {params: params});
    return res.data;
  },
  getListStorePhanQuyen: async params => {
    const url =
      "/store/store/by-nhom-kho?nhom-kho=KI&isKhoAo=true&isPhanQuyen=true";
    const res = await axiosClient.get(url, {params: params});
    return res.data;
  },
  getListManufacturer: async () => {
    const url = "/store/manufacturer/groups-kinh";
    const res = await axiosClient.get(url);
    return res.data;
  },
  createManufacturer: async body => {
    const url = "/store/manufacturer/groups-kinh";
    const res = await axiosClient.post(url, body);
    return res.data;
  },
  editManufacturer: async body => {
    const url = "/store/manufacturer/groups-kinh";
    const res = await axiosClient.put(url, body);
    return res.data;
  },
  deleteManufacturer: async id => {
    const url = "/store/manufacturer/delete";
    const param = {id: id};
    const res = await axiosClient.delete(url, {params: param});
    return res;
  },
  getListKVT: async param => {
    const url = "/store/kinh-vt/list-kinh-vt";
    const res = await axiosClient.get(url, {params: param});
    return res.data;
  },
  getListKVTByParams: async params => {
    const url = "/store/kinh-vt/searchKey";
    const res = await axiosClient.get(url, {params: params});
    return res.data;
  },
  getListKVTNoPage: async param => {
    const url = "/store/kinh-vt/list-kinh-vt-no-page";
    const res = await axiosClient.get(url, {params: param});
    return res.data;
  },

  createKVT: async body => {
    const url = "/store/kinh-vt/create";
    const res = await axiosClient.post(url, body);
    return res.data;
  },

  editKVT: async body => {
    const url = "/store/kinh-vt/update";
    const res = await axiosClient.put(url, body);
    return res.data;
  },

  deleteKVT: async id => {
    const url = "/store/kinh-vt/delete";
    const param = {id: id};
    const res = await axiosClient.delete(url, {params: param});
    return res;
  },

  getListDMVL: async param => {
    const url = "/store/material/list-material";
    const res = await axiosClient.get(url, {params: param});
    return res.data;
  },

  createListDMVL: async body => {
    const url = "/store/material/create";
    const res = await axiosClient.post(url, body);
    return res.data;
  },

  editListDMVL: async body => {
    const url = "/store/material/update";
    const res = await axiosClient.put(url, body);
    return res.data;
  },

  deleteDMVL: async id => {
    const url = "/store/material/delete";
    const param = {id: id};
    const res = await axiosClient.delete(url, {params: param});
    return res;
  },

  getListStoreGlassCategory: async param => {
    const url = "/store/store/groups-kinh";
    const res = await axiosClient.get(url, {params: param});
    return res.data;
  },

  createStoreGlassCategory: async body => {
    const url = "/store/store/groups-kinh";
    const res = await axiosClient.post(url, body);
    return res.data;
  },

  editStoreGlassCategory: async body => {
    const url = "/store/store/groups-kinh";
    const res = await axiosClient.put(url, body);
    return res.data;
  },

  deleteStoreGlassCategory: async id => {
    const url = "/store/store/delete";
    const param = {id: id};
    const res = await axiosClient.delete(url, {params: param});
    return res;
  },

  getListColorCategory: async param => {
    const url = "/store/mau-sac/paging";
    const res = await axiosClient.get(url, {params: param});
    return res.data;
  },

  createColorCategory: async body => {
    const url = "/store/mau-sac/create";
    const res = await axiosClient.post(url, body);
    return res.data;
  },

  editColorCategory: async body => {
    const url = "/store/mau-sac/update";
    const res = await axiosClient.put(url, body);
    return res.data;
  },

  deleteColorCategory: async id => {
    const url = "/store/mau-sac/delete";
    const param = {id: id};
    const res = await axiosClient.delete(url, {params: param});
    return res;
  },

  getListVatTuKinhByParams: async params => {
    const url = "/store/kinh-vt/list-kinh-vt-no-page";
    const res = await axiosClient.get(url, {params: params});
    return res.data;
  },
  getListVatTuKinhInStoreByParams: async params => {
    const url = "/store/glasses-store/list-glasses-in-store";
    const res = await axiosClient.get(url, {params: params});
    return res.data;
  },
  getListLoInStoreByParams: async params => {
    const url = "/store/glasses-store/searchKey";
    const res = await axiosClient.get(url, {params: params});
    return res.data;
  },
  getDetailVatTuKinhById: async id => {
    const url = "/store/kinh-vt/by-id";
    const params = {id: id};
    const res = await axiosClient.get(url, {params: params});
    return res.data;
  },
  getDetailLo: async (soLo, khoId) => {
    const url = "/store/glasses-store/by-so-lo";
    const params = {soLo: soLo, storeId: khoId};
    const res = await axiosClient.get(url, {params: params});
    return res.data;
  },

  updateDetailLo: async params => {
    const url = "/store/glasses-store/update";
    const res = await axiosClient.put(url, params);
    return res.data;
  },
  getLichSuXuatNhapBySoLo: async soLo => {
    const url = "/store/glasses-store/lich-su-xn";
    const params = {soLo: soLo};
    const res = await axiosClient.get(url, {params: params});
    return res.data;
  },
  getCountByStore: async storeId => {
    const url = "/store/glasses-store/get-count";
    const params = {storeId: storeId};
    const res = await axiosClient.get(url, {params: params});
    return res.data;
  },
  authorUser: async data => {
    const url = "/store/store/update-account-store";
    const res = await axiosClient.put(url, data);
    return res.data;
  },
};

export default glassStoreService;
